import { useState, useEffect } from 'react';
import './style.css';
import T from 'i18n-react';
import ImpInfoIcon from '../../images/SkipAuthInfoIcon.svg';
import InstructionsIcon from '../../images/SkipAuthInstructionsIcon.svg';

const AuthorizeSkipCRA = (props) => {
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        if (props.onAuthorizationComplete) {
            props.onAuthorizationComplete(checked);
        }
    }, [checked]);

    const onCheckboxClick = () => {
        setChecked((prev) => !prev);
    }

    return (
        <div className='authorizeMyAccountContainerStyle'>
            <div className='authorizeMyAccountCRAInstructionsWrapper'>
                <div className='authorizeMyAccountCRATitle'>{T.translate('Authorize.SkipAuth.Title')}</div>
                <div className='authorizeSkipSubTitle'>{T.translate('Authorize.SkipAuth.SubTitle')}</div>
                <div className='authorizeSkipImpInfoWrapper'>
                    <div className='authorizeSkipImpInfoHeaderWrapper'>
                        <img src={ImpInfoIcon} className='authorizeSkipImpInfoIcon' />
                        <div className='authorizeSkipImpInfoHeader'>{T.translate('Authorize.SkipAuth.ImpInfoHeader')}</div>
                    </div>
                    <div className='authorizeSkipImpInfoText'>
                        {T.translate('Authorize.SkipAuth.ImpInfo')}
                    </div>
                </div>
                <div className='authorizeSkipInstructionsWrapper'>
                    <img src={InstructionsIcon} className='authorizeSkipInstructionsIcon' />
                    <div>
                        <div className='authorizeSkipInstructionsText'>{T.translate('Authorize.SkipAuth.Instructions1')}</div>
                        <div className='authorizeSkipInstructionsText'>
                            {T.translate('Authorize.SkipAuth.Instructions2')}
                            <a className='authorizeLinkStyle' onClick={() => window.open(T.translate('Authorize.SkipAuth.CanadianTaxChecklistLink'), '_blank', 'noopener noreferrer')}>
                                {T.translate('Authorize.SkipAuth.CanadianTaxChecklist')}
                            </a>
                            
                        </div>
                        <div>{T.translate('Authorize.SkipAuth.Instructions3')}</div>
                    </div>
                </div>
                <div className='authorizeSkipConfirmation' onClick={onCheckboxClick}>
                    <div className='authorizeSkipCheckbox'>
                        { !checked ? 
                            (<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                <path d="M22.1667 5.83333V22.1667H5.83333V5.83333H22.1667ZM22.1667 3.5H5.83333C4.55 3.5 3.5 4.55 3.5 5.83333V22.1667C3.5 23.45 4.55 24.5 5.83333 24.5H22.1667C23.45 24.5 24.5 23.45 24.5 22.1667V5.83333C24.5 4.55 23.45 3.5 22.1667 3.5Z" fill="black" fill-opacity="0.6"/>
                            </svg>) 
                            :
                            (<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                <path d="M22.1667 3.5H5.83333C4.53833 3.5 3.5 4.55 3.5 5.83333V22.1667C3.5 23.45 4.53833 24.5 5.83333 24.5H22.1667C23.4617 24.5 24.5 23.45 24.5 22.1667V5.83333C24.5 4.55 23.4617 3.5 22.1667 3.5ZM11.6667 19.8333L5.83333 14L7.47833 12.355L11.6667 16.5317L20.5217 7.67667L22.1667 9.33333L11.6667 19.8333Z" fill="#2E7D32"/>
                            </svg>)
                        }
                    </div>
                    <div className='skipConfirmationText'>{T.translate('Authorize.SkipAuth.Confirmation')}</div>
                </div>
            </div>
        </div>
    );
};

export default AuthorizeSkipCRA;